const requireModule = require.context('.', true, /\.js$/)
const modules = {}
const accessFile = ['actions.js', 'getters.js', 'mutations.js', 'state.js']

// 特定の条件を満たすファイル（この場合はVuexストアモジュール）を動的に読み込む
// 特定のコンテキストに一致するすべてのモジュールのキー（ファイルパス）を返します
requireModule.keys().map(fileName => {
    if (fileName === 'module.js.js') return

    console.log(fileName)

    // nこれは、Vuexストアのモジュールが名前空間を持つことを意味し、モジュール内のアクション、ミューテーション、ゲッターがグローバル名前空間を汚染しないようにします
    const moduleDefault = {
        namespaced: true
    }
    
    // ファイル名からモジュール名を抽出するために、fileName.split('/')を使用してパスを分割し、_.nth(namePath, 1)でフォルダ名を取得します。
    const namePath = fileName.split('/')
    const folderName = _.nth(namePath, 1)

    // namePath配列の最後の要素がaccessFile文字列内に存在するかどうか、そして存在する場合はその位置を調べるために使用されています。
    if (accessFile.indexOf(_.last(namePath)) === -1) return

    // フォルダ名が存在する場合、moduleNameをnullで初期化し、フォルダ名が.jsで終わらない場合に限り、
    // moduleNameにキャメルケースで変換したフォルダ名を設定します。この変換には_.camelCase関数が使用されます。
    if (folderName) {
        let moduleName = null
        
        if (!_.endsWith(folderName, '.js')) {
            moduleName = _.camelCase(
                folderName.replace(/(\.\/|\.js)/g, '')
            )

            if (!(moduleName in modules))
                modules[moduleName] = moduleDefault
        }

        // modulesオブジェクトにmoduleNameがまだ存在しない場合、moduleDefaultをそのキーに割り当てます。
        // そして、moduleNameがmodulesオブジェクトに存在する場合、requireModule(fileName).defaultを使用してモジュールのデフォルトエクスポートを読み込み、その内容をmodules[moduleName]にマージします。
        if (moduleName in modules) {
            const storeObjName = _.last(namePath).replace(/(\.\/|\.js)/g, '')
            const obj = {}
            obj[storeObjName] = {...requireModule(fileName).default}
            _.assignIn(modules[moduleName], obj)
        }
    }
})

export default modules
